import {Injectable} from '@angular/core';
import {Feature} from '@catcore/services/feature/feature';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class FeatureService extends RestHttpService<Feature> {

  constructor(service: Restangular) {
    super('features', service);
  }

  /**
   * Returns all option tokens available within the given feature.
   *
   * @param feature
   */
  getOptionTokens(feature: Feature) {
    return this.getAllSubresources(feature.id, 'option-tokens');
  }

  /**
   * Returns all ggw devices available within the given feature.
   *
   * @param feature
   */
  getGgwDevices(feature: Feature) {
    return this.getAllSubresources(feature.id, 'ggw-devices');
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/services/feature/feature.service.ts